module.exports = __webpack_public_path__ + "static/media/GrayFolder.2f89e492.svg";